import { poe2 } from "../../../game";

export const currencyDisplayLabelMap = poe2 ? [
  { name: "Twilight Reliquary Key", displayLabel: "Twilight Key" },
  { name: "Xesht's Reliquary Key", displayLabel: "Xesht's Key" },
  { name: "The Trialmaster's Reliquary Key", displayLabel: "The Trialmaster's Key" },
  { name: "Ritualistic Reliquary Key", displayLabel: "Ritualistic Key" },
  { name: "Tangmazu's Reliquary Key", displayLabel: "Tangmazu's Key" },
  { name: "Olroth's Reliquary Key", displayLabel: "Olroth's Key" },
  { name: "The Arbiter's Reliquary Key", displayLabel: "The Arbiter's Key" },
  { name: "Zarokh's Reliquary Key: Against the Darkness", displayLabel: "Zarokh's Key: AtD" },
  { name: "Zarokh's Reliquary Key: Sandstorm Visage", displayLabel: "Zarokh's Key: Sandstorm" },
  { name: "Zarokh's Reliquary Key: Blessed Bonds", displayLabel: "Zarokh's Key: Blessed" },
  { name: "Zarokh's Reliquary Key: Sekhema's Resolve", displayLabel: "Zarokh's Key: Sekhema's" },
  { name: "Zarokh's Reliquary Key: Temporalis", displayLabel: "Zarokh's Key: Temporalis" },
] : [];
